/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */

export enum WizardStepNames {
  INFO,
  KEYS_FORM,
  DEPOSIT,
}
